import { TerminalEvent } from './terminal-event.js'

/**
 * Paste event fired when bracketed paste data is received.
 *
 * The terminal wraps pasted text in ESC[200~ ... ESC[201~ sequences
 * when bracketed paste mode is enabled (DECSET 2004).
 */
export class PasteEvent extends TerminalEvent {
	/** The pasted text content */
	readonly data: string

	constructor(data: string) {
		super('paste', { bubbles: true, cancelable: true })
		this.data = data
	}
}
